import React from "react";
import { Box, Button } from "@mui/material";
import EditProperties from "./EditProperties";

const FieldMenu = ({
  sections,
  setSections,
  sectionId,
  fieldId,
  field,
  handleUpdateFieldLabel,
  handleUpdateFieldProperty,
  setInputFieldMenuOpen,
  handleRemoveField,
}) => {
  console.log("inside field menu")
  return (
    <Box
      sx={{
        width: "19rem",
        bgcolor: "#fff",
        overflow: "hidden",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "0.5rem",
      }}
    >
      <Box>
        <EditProperties
          setSections={setSections}
          sectionId={sectionId}
          fieldId={fieldId}
          field={field}
          handleUpdateFieldLabel={handleUpdateFieldLabel}
          handleUpdateFieldProperty={handleUpdateFieldProperty}
          setInputFieldMenuOpen={setInputFieldMenuOpen}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          backdropFilter: "blur(4px)",
          WebkitBackdropFilter: "blur(4px)",
          position: "sticky",
          bottom: "0rem",
          left: "0rem",
          p: "0.3rem",
        }}
      >
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleRemoveField(sectionId, fieldId)}
          color="error"
          sx={{ fontSize: "0.7rem" }}
        >
          Remove field
        </Button>
      </Box>
    </Box>
  );
};

export default FieldMenu;
